//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        appear: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        /** @param {HTMLElement} el */
        enter(el) {
            el.style.height = 'auto';
            const elHeight = getComputedStyle(el).height;
            el.style.height = '1px';
            el.offsetHeight; // force repaint
            el.style.height = elHeight;
        },
        /** @param {HTMLElement} el */
        afterEnter(el) {
            el.style.removeProperty('height');
            this.$emit('enter');
        },
        /** @param {HTMLElement} el */
        beforeLeave(el) {
            el.style.height = getComputedStyle(el).height;
            el.offsetHeight; // force repaint
            el.style.height = '0px';
        },
        /** @param {HTMLElement} el */
        afterLeave(el) {
            el.style.removeProperty('height');
            this.$emit('leave');
        },
    },
};
